import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <g>
    <g stroke="null" id="Icon" xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="null"
        fill="#008060"
        d="m18.67082,7.24366l0.00945,14.13503l2.69845,0l0,-18.75739l-18.75743,0l0,2.69839l14.13507,0.00939l-14.13507,14.13495l1.91458,1.91466l14.13495,-14.13503z"
        id="color-fix"
      />
    </g>
    <path
      stroke="null"
      d="m18.67082,7.24366l0.00945,14.13503l2.69845,0l0,-18.75739l-18.75743,0l0,2.69839l14.13507,0.00939l-14.13507,14.13495l1.91458,1.91466l14.13495,-14.13503z"
      id="color-fix"
      xmlns="http://www.w3.org/2000/svg"
    />
  </g>,
  "Increase"
);
